var app = angular.module("leonardo");

var EmailVendorDialog = function($scope, VendorService, NotificationService, FormErrorsService) {
  $scope.vendor = angular.copy($scope.ngDialogData.vendor);

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.vendor.contact({subject: $scope.subject, message: $scope.message}).then(function(){
      $scope.closeThisDialog();
      NotificationService.notify('success', 'Email has been sent to vendor');
    });
  };
};

app.controller('EmailVendorDialog', ['$scope', 'VendorService', 'NotificationService', 'FormErrorsService',
  EmailVendorDialog]);
